import React, { useState } from "react"
import { SearchPromoCard } from "terra-one"
import formatIcons from "../formatIcons"
import { withinDateRange } from "../../../components/OverlayNotice/OverlayNoticeMethods"

const FormatAndRenderSearchPromoCard = ({ data, locale }) => {
  const [displayPromoCard, setDisplayPromoCard] = useState(false)

  const msInDay = 60 * 60 * 24 * 1000

  const getStoredPromoCard = id =>
    JSON.parse(localStorage?.getItem(`search-promo-card-${id}`))

  const setStoredPromoCard = (id, entry) =>
    localStorage?.setItem(`search-promo-card-${id}`, JSON.stringify(entry))

  const checkDisplayPromoCard = (currentDate, id, redisplayDays) => {
    if (typeof window === "undefined") return false

    const storedEntry = getStoredPromoCard(id)
    if (!storedEntry) return true

    const promoCardDismissedDate = storedEntry.date
    const differenceDays = Math.floor(
      (currentDate - promoCardDismissedDate) / msInDay
    )

    if (storedEntry.redisplay !== redisplayDays) {
      setStoredPromoCard(id, {
        date: promoCardDismissedDate,
        redisplay: redisplayDays ?? false,
      })
      return false
    }

    if (storedEntry.redisplay === false || storedEntry.redisplay === 0)
      return false

    if (differenceDays >= storedEntry.redisplay) {
      localStorage.removeItem(`search-promo-card-${id}`)
      return true
    }

    return false
  }

  return data?.map((promoCard, i) => {
    const formattedIcons = promoCard?.icons?.map(promoIcon => ({
      type: formatIcons(promoIcon?.icon),
    }))

    const inDateRange =
      promoCard?.startDate && promoCard?.endDate
        ? withinDateRange(promoCard.startDate, promoCard.endDate)
        : true

    const formattedCtaLink = {
      text: promoCard?.ctaLink?.url?.text,
      url: `/${locale}/${promoCard?.ctaLink?.url?.url}`,
    }

    return (
      <SearchPromoCard
        key={i}
        contentful_id={promoCard?.contentfulId}
        id={promoCard?.id}
        header={promoCard?.cardHeader}
        label={promoCard?.cardLabel}
        eyebrow={promoCard?.eyebrow}
        text={promoCard?.cardText}
        linkLabel={promoCard?.linkLabel}
        icons={formattedIcons}
        cta={formattedCtaLink}
        destination={promoCard?.cardUrl}
        redisplayDays={promoCard?.redisplayDays}
        inDateRange={inDateRange}
        displayPromoCard={displayPromoCard}
        setStoredPromoCard={setStoredPromoCard}
        setDisplayPromoCard={setDisplayPromoCard}
        checkDisplayPromoCard={checkDisplayPromoCard}
      />
    )
  })
}

export default FormatAndRenderSearchPromoCard
